<div class="position-fixed side-navbar" *ngIf="authService.isAuthenticated()" style="z-index:999 !important">
    <div class="d-flex justify-content-center align-items-center" [ngClass]="{'flex-column h-100': desktop,'bg-dark':!desktop}">
        <img src="../../assets/images/app.png" alt="" class="m-3 icon" 
            [ngClass]="{'ml-5 px-3': desktop}" 
            *ngIf="authService.isAuthenticated() && showOnMenu('app')" 
            (click)="changeActive('app')" 
        >
        <img src="../../assets/images/transactions.png" alt="" class="m-3 icon" 
            [ngClass]="{'ml-5 px-3': desktop}" 
            *ngIf="authService.isAuthenticated() && showOnMenu('transactions')" 
            (click)="changeActive('transactions')" 
        >
        <img src="../../assets/images/wallet.png" alt="" class="m-3 icon" 
            [ngClass]="{'ml-5 px-3': desktop}" 
            *ngIf="authService.isAuthenticated() && showOnMenu('connect')" 
            (click)="connectWallet()"
        >
    </div>
</div>